import { useParams, useSearchParams } from 'react-router-dom';
import { useReportQuery } from '../hooks/useReportQuery';
import ChartWithTransactions from './ChartWithTransactions';

const ReportView = () => {
  const { reportId } = useParams<{ reportId: string }>();
  const [searchParams] = useSearchParams();
  const beginDate = searchParams.get('begin') ?? undefined;
  const endDate = searchParams.get('end') ?? undefined;
  console.log('beginDate', beginDate);
  console.log('endDate', endDate);
  const { data: report, isLoading, error } = useReportQuery(reportId!, beginDate, endDate);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Rice Stock Report</h1>
      <ChartWithTransactions riceData={report?.data as any} />
    </div>
  );
};

export default ReportView; 